import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import React from 'react'
import PropTypes from 'prop-types'
import Paginated from 'meteor-paginated-graphql-react'
import Loading from 'orionsoft-parts/lib/components/Loading'
import Actions from 'src/App/components/Actions'
import styles from './styles.css'
import withOrganization from 'App/Decorators/withOrganization'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import Button from 'orionsoft-parts/lib/components/Button'
import MdGroup from 'react-icons/lib/md/group'
import {withRouter} from 'react-router'
import MdCancel from 'react-icons/lib/md/cancel'
import FaExternalLink from 'react-icons/lib/fa/external-link'

@withMessage
@withMutation(gql`
  mutation removeMember($memberId: ID, $organizationId: ID) {
    removeMember(memberId: $memberId, organizationId: $organizationId) {
      success
    }
  }
`)
@withMutation(gql`
  mutation passOwner($memberId: ID, $organizationId: ID) {
    passOwner(memberId: $memberId, organizationId: $organizationId) {
      success
    }
  }
`)
@withOrganization
@withRouter
export default class Administration extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    organization: PropTypes.object,
    removeMember: PropTypes.func,
    passOwner: PropTypes.func
  }

  getFields() {
    return [
      {title: '', name: '_id', render: () => <MdGroup />},
      {
        title: 'Email',
        name: 'email',
        render: item => item.email
      },
      {
        title: 'Confirmado',
        name: 'userId',
        render: item => (item.userId ? 'Si' : 'No')
      },
      {
        title: 'Rol',
        name: 'roles'
      },
      {
        title: '',
        name: ' ',
        render: item => this.renderActions(item)
      }
    ]
  }

  renderActions(item) {
    if (this.props.organization.myRole[0] === 'member') return
    return (
      <span style={{float: 'right', width: 200, textAlign: 'right'}}>
        <Actions options={this.renderOptions(item)} />
      </span>
    )
  }

  renderPassProperty(item) {
    return (
      <div onClick={() => this.passProperty(item)} style={{width: 220}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <FaExternalLink size={20} style={{color: 'blue'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Transferir la propiedad</div>
          </div>
        </span>
      </div>
    )
  }

  renderDeleteMember(item) {
    return (
      <div onClick={() => this.removeMember(item)} style={{width: 220}}>
        <span>
          <div className="row">
            <div className="col-xs-12 col-sm-2">
              <MdCancel size={20} style={{color: 'red'}} />
            </div>
            <div className="col-xs-12 col-sm-9">Eliminar Usuario</div>
          </div>
        </span>
      </div>
    )
  }

  renderOptions(item) {
    if (this.props.organization.myRole[0] === 'owner') {
      return [this.renderPassProperty(item), this.renderDeleteMember(item)]
    } else {
      return [this.renderDeleteMember(item)]
    }
  }

  async passProperty(item) {
    this.setState({loading: true, errorMessages: null})
    try {
      await this.props.passOwner(
        {memberId: item._id, organizationId: this.props.organization._id},
        {
          refetchQueries: ['organization', 'organizationUsers']
        }
      )
      this.props.router.push('/')
      this.props.showMessage('Propiedad de organización transferida')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  async removeMember(item) {
    this.setState({loading: true})
    try {
      await this.props.removeMember(
        {
          memberId: item._id,
          organizationId: this.props.organization._id
        },
        {
          refetchQueries: ['usersCount', 'organizationUsers']
        }
      )
      this.props.showMessage('Miembro eliminado satisfactoriamente')
      this.refs.paginated.reload()
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderAdd() {
    if (this.props.organization.myRole[0] === 'member') return
    return (
      <div>
        <Button primary to={`/organization/users/add`}>
          Agregar Miembro
        </Button>
      </div>
    )
  }

  render() {
    if (!this.props.organization._id) {
      this.props.router.push('/')
    }
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="table">
            <Paginated
              loadingComponent={Loading}
              queryName="organizationUsers"
              fields={this.getFields()}
              ref="paginated"
              organization={this.props.organization._id}
              params="$filter: String $organization: String"
            />
          </div>
        </div>
        {this.renderAdd()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Organizations/Administration/Main/index.js